module.exports = __webpack_public_path__ + "img/Square_4Cards.96c156ea.png";